
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IClassCode, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ItemClassLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemClassLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<IClassCode[]> {
        return this.$apiService.sendAuth("IItemClassLookupService/Lookup", pCriteria);
    }
}
